import { useAuthContext } from '../contexts/AuthContext';

/**
 * Shown when the token signals `ams_error=unavailable` — AMS was unreachable
 * when the token was minted, so account context could not be resolved. This is
 * a transient service outage, NOT a missing account, so it is visually and
 * textually distinct from AccountNotProvisioned (red/error framing, "try
 * again" affordance).
 *
 * Styled to match the full-screen centered states in AuthGate (App.tsx).
 */
export default function AmsUnavailable() {
  const { logout } = useAuthContext();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="flex flex-col items-center gap-4 max-w-md text-center p-6">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/30">
          <svg
            className="h-6 w-6 text-red-600 dark:text-red-400"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.8}
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
        </div>
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
          Account service is temporarily unavailable
        </h1>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          We couldn&apos;t reach the account service to load your details. This
          is usually temporary — please refresh in a few moments. If it keeps
          happening, contact your administrator.
        </p>
        <div className="mt-2 flex items-center gap-3">
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md text-sm hover:bg-indigo-700 transition-colors"
          >
            Try again
          </button>
          <button
            onClick={logout}
            className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-md text-sm hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
